const sortedEnum = Object.freeze({
  ASCENDING: 'asc',
  DESCENDING: 'desc',
});
export default sortedEnum;
